class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]:not([type="hidden"])')
    ).reduce((total, input) => total + parseInt(input.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      body
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        });

        // BOLD Cart Section Reload
        BOLD.common.themeCartCallback = function () {
          const sections = this.getSectionsToRender().map((section) => section.section).join();
          fetch(`/?sections=${sections}`, { method: 'GET' })
            .then((response) => response.text())
            .then((state) => {
              const pState = JSON.parse(state);
              this.getSectionsToRender().forEach((section) => {
                const elementToReplace =
                  document.getElementById(section.id).querySelector(section.selector) ||
                  document.getElementById(section.id);

                elementToReplace.innerHTML = this.getSectionInnerHTML(pState[section.section], section.selector);
              });
            });
        }.bind(this);

        BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded", parsedState);

        // Remove hidden products from item count
        parsedState.items.forEach((item) => {
          if (item.product_type && item.product_type.includes("HIDDEN_PRODUCT")) {
            parsedState.item_count -= item.quantity;
          }
        });

        this.updateLiveRegions(line, parsedState.item_count);

        const lineItem = document.getElementById(`CartItem-${line}`) ||
                         document.getElementById(`CartDrawer-Item-${line}`);

        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        this.disableLoading();

        if (typeof window.BOLD?.common?.eventEmitter?.emit === 'function') {
          BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
        }

      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) ||
                            document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) ||
                              document.getElementById(`Drawer-quantity-${line}`);

      lineItemError.querySelector('.cart-item__error-text').innerHTML =
        window.cartStrings.quantityError.replace('[quantity]', quantityElement.value);
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') ||
                       document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
      if (typeof window.BOLD?.common?.eventEmitter?.emit === 'function') {
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
      }
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    if (document.body.classList.contains('itg_cart')) {
      location.reload(true);
    }
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('change', debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body });
        }, 300));
      }
    }
  );
}

function handleFreeProductBasedOnDiscount(cart) {
  var noscript = document.getElementById('custom-discount-data');
  if (!noscript) return;

  var discountCode = noscript.getAttribute('discount-code');
  var freeProductVariant = noscript.getAttribute('free-product-variant');
  var freeProductSP = noscript.getAttribute('free-product-SP');
  var eligibleVariants = noscript.getAttribute('eligible-products-variants');

  if (!discountCode || !freeProductVariant || !eligibleVariants) return;

  discountCode = discountCode.trim().toLowerCase();
  eligibleVariants = eligibleVariants.split(',').map(v => v.trim());

  var hasDiscount = cart.discount_codes?.some(code => code.code.toLowerCase() === discountCode && code.applicable);
  var hasFreeProduct = cart.items.some(item => item.variant_id == freeProductVariant);

  var eligibleItem = null;
  for (var i = 0; i < cart.items.length; i++) {
    if (eligibleVariants.includes(cart.items[i].variant_id.toString())) {
      eligibleItem = cart.items[i];
      break;
    }
  }

  if (hasDiscount && eligibleItem && !hasFreeProduct) {
    var formData = new FormData();
    formData.append('id', freeProductVariant);
    formData.append('quantity', '1');
    formData.append('properties[_auto_added]', 'true');
    var sellingPlanId = eligibleItem.selling_plan_allocation?.selling_plan?.id;
    if (sellingPlanId) {
      formData.append('selling_plan', freeProductSP);
    }

    fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      body: formData
    }).then(res => res.json()).then(() => {
      location.reload();
    });

  } else if ((!hasDiscount || !eligibleItem) && hasFreeProduct) {
    console.log('(!hasDiscount || !eligibleItem) && hasFreeProduct');
    var lineItem = cart.items.find(item => item.variant_id == freeProductVariant && item.properties?._auto_added);
    if (lineItem) {
      const updateData = new FormData();
      updateData.append('updates[' + lineItem.key + ']', 0);
      updateData.append('discount', '');
    
      fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        body: updateData
      })
      .then(() => {
        location.reload();
      });
    }
  }
}

function fetchCartAndHandleFreeProduct() {
  fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
  .then(res => res.json())
  .then(cart => {
    handleFreeProductBasedOnDiscount(cart);
  })
  .catch(console.error);
}

document.addEventListener('DOMContentLoaded', fetchCartAndHandleFreeProduct);

document.addEventListener('BOLD_COMMON_cart_loaded', function (event) {
  var cart = event.detail || window.BOLD?.cartData || null;
  if (cart) {
    handleFreeProductBasedOnDiscount(cart);
  } else {
    fetchCartAndHandleFreeProduct();
  }
});